
import FingerScan from "../../../assets/outline/FingerScan.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function FingerScanIcon({ className, dataTestid = "FingerScanIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <FingerScan data-testid={dataTestid} className={classes} {...rest} />
  );
}
